var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilletAlternatif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 971,
    height: 971,
    viewBox: "0 0 971 971",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5565_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M887.113 534.935L535.935 886.113C466.778 955.27 354.251 955.27 285.094 886.113L261.966 862.986C248.12 849.139 248.12 826.664 261.966 812.818C262.568 812.216 263.321 811.513 264.098 810.836C291.315 782.566 290.989 737.39 263.095 709.496C235.202 681.602 190 681.251 161.73 708.468C161.053 709.245 160.35 709.998 159.774 710.575C145.927 724.421 123.452 724.421 109.605 710.575L84.4207 685.39C15.2637 616.283 15.2637 503.756 84.4207 434.599L435.599 83.4207C504.756 14.2637 617.283 14.2637 686.44 83.4207L711.524 108.505C725.371 122.351 725.371 144.827 711.524 158.673C683.857 186.341 683.857 231.342 711.524 259.01C739.192 286.678 784.193 286.678 811.861 259.01C825.707 245.163 848.183 245.163 862.029 259.01L887.113 284.094C956.27 353.251 956.27 465.778 887.113 534.935Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5565_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 971,
    height: 971,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilletAlternatif);
export default __webpack_public_path__ + "static/media/billet-alternatif.398e4ecab52e7b5537acddd1ffa9d07a.svg";
export { ForwardRef as ReactComponent };